import Notify from "./Notify";
import Navigation from "./Navigation";
// import * as RestaurantHoursPS from "../../../output/Components.RestaurantHoursPS/index.js";
import forwardTo from "../utils/forwardTo";
import Cmd from "../utils/Cmd";
import PsToJs from "./PsToJs";
import { getCurrentRestaurantSlug } from "../utils/CurrentRestaurant";
import RestaurantHoursTS from "../components/RestaurantHours";
class RestaurantHours {
    static init(state) {
        return RestaurantHoursTS.init(state);
    }
    static update(state, action) {
        return RestaurantHoursTS.update(state, action);
    }
    static loadViewFn() {
        this._view = { state: "loading" };
        import("../../../output/Components.RestaurantHoursPS/index.js").then((mod) => {
            const RestaurantHoursPS = PsToJs(mod);
            this._view = { state: "ready", view: RestaurantHoursPS.view };
            this._deferedViews.forEach((deferedView) => deferedView());
            this._deferedViews = [];
        });
    }
    static view(element, restaurantHours, dispatch) {
        switch (this._view.state) {
            case "empty":
                this.loadViewFn();
            // NOTICE Intentionally no break
            case "loading":
                this._deferedViews.push(() => {
                    this.view(element, restaurantHours, dispatch);
                });
                break;
            case "ready":
                this._view.view(element, restaurantHours, dispatch);
        }
    }
}
RestaurantHours._deferedViews = [];
RestaurantHours._view = { state: "empty" };
const { assign } = Object;
/**
 * Initiate state for App component.
 *
 * @param {State} state Object containing initial state.
 * @returns {*[]}
 */
function init(state) {
    const [notifyState, notifyCmd] = Notify.init(state.notify || []);
    const [navigationState, navigationCmd] = Navigation.init(state.navigation || {});
    const [restaurantHoursState, restaurantHoursCmd] = RestaurantHours.init(state.restaurantHours || {});
    return [
        assign({}, state, {
            notify: notifyState,
            navigation: navigationState,
            restaurantHours: restaurantHoursState,
        }),
        Cmd.batch(notifyCmd.tag("NOTIFY_ACTION"), navigationCmd.tag("NAVIGATION_ACTION"), restaurantHoursCmd.tag("RESTAURANT_HOURS_ACTION"), Cmd.of((dispatch) => {
            document.addEventListener("change-restaurant.restaumatic", () => {
                // Should cause a rerender of RestaurantHours
                dispatch({ type: "NOOP" });
            });
        })),
    ];
}
/**
 * Update component state using proper child update method.
 *
 * @returns {*[]}
 */
function update(state, action) {
    switch (action.type) {
        case "NOTIFY_ACTION":
            const [notifyState, notifyCmd] = Notify.update(state.notify, action.payload);
            return [
                Object.assign({}, state, { notify: notifyState }),
                notifyCmd.tag("NOTIFY_ACTION"),
            ];
        case "NAVIGATION_ACTION":
            const [navigationState, navigationCmd] = Navigation.update(state.navigation, action.payload);
            return [
                Object.assign({}, state, { navigation: navigationState }),
                navigationCmd.tag("NAVIGATION_ACTION"),
            ];
        case "RESTAURANT_HOURS_ACTION":
            const [restaurantHoursState, restaurantHoursCmd] = RestaurantHours.update(state.restaurantHours, action.payload);
            return [
                assign({}, state, { restaurantHours: restaurantHoursState }),
                restaurantHoursCmd.tag("RESTAURANT_HOURS_ACTION"),
            ];
        default:
            return [state, Cmd.none];
    }
}
/**
 * Update the view.
 */
function view(element, state, dispatch) {
    if (document.querySelector(".js-notify")) {
        Notify.view(".js-notify", state.notify, forwardTo(dispatch, "NOTIFY_ACTION"));
    }
    if (document.querySelector(".js-navigation")) {
        Navigation.view(".js-navigation", state.navigation, forwardTo(dispatch, "NAVIGATION_ACTION"));
    }
    const restaurantHours = document.querySelectorAll(".js-restaurant-hours");
    for (const restaurantHourComponent of restaurantHours) {
        if (restaurantHourComponent.getAttribute("data-restaurant-slug") ===
            getCurrentRestaurantSlug()) {
            RestaurantHours.view(restaurantHourComponent, state.restaurantHours, forwardTo(dispatch, "RESTAURANT_HOURS_ACTION"));
        }
    }
}
export default {
    init,
    update,
    view,
};
